enum UserFeedback {
  API_KEY_EDIT_FAILED = "EDIT_API_KEY_FAILED",
  API_KEY_EDIT_UPDATED = "API_KEY_EDIT_UPDATED",
  API_KEY_GET_FAILED = "GET_API_KEY_FAILED",
  CREATE_NEW_API_KEY_FAILED = "CREATE_NEW_API_KEY_FAILED",
  CREATE_NEW_API_KEY_SUCCESS = "CREATE_NEW_API_KEY_SUCCESS",
  DELETE_API_KEY_SUCCESS = "DELETE_API_KEY_SUCCESS",
  DELETE_API_KEY_FAILED = "DELETE_API_KEY_FAILED",
  DEVICES_GET_FAILED = "DEVICES_GET_FAILED",
  DEVICE_REMOVE_FAILED = "DEVICE_REMOVE_FAILED",
  DEVICE_REMOVED = "DEVICE_REMOVED",
  DEVICE_NOT_VERIFIED = "DEVICE_NOT_VERIFIED",
  GET_API_KEY_RESPONSE = "GET_API_KEY_RESPONSE",
  LOGIN_FAILED = "LOGIN_FAILED",
  PASSWORD_CHANGED = "PASSWORD_CHANGED",
  PASSWORD_CHANGE_FAILED = "PASSWORD_CHANGE_FAILED",
  PASSWORD_REST = "PASSWORD_REST",
  PASSWORD_RESET_FAILED = "RESET_PASSWORD_FAILED",
  USERNAME_MISSING = "USERNAME_MISSING"
}

export default UserFeedback;
